/* eslint-disable */
import React, { Fragment, useReducer, useState } from 'react'
import { Button, Row, Col, Offcanvas, OffcanvasHeader, OffcanvasBody, Form, Label, Input, FormFeedback } from 'reactstrap'
import Flatpickr from 'react-flatpickr'
import AsyncSelect from 'react-select/async'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { configGetMagazzini } from '../../../../@core/auth/apiService/configs'
import axios from 'axios'
import toast from 'react-hot-toast'
import moment from 'moment'
import TestTabella from './TestTabella'
import { configSetMovimentiMagazzino } from '../../../../@core/auth/apiService/configs'

let initialState = {
    idMagazzinoPartenza: '',
    idMagazzinoDestinazione: 0,
    dataOperazione: moment().format('YYYY-MM-DD'),
    prodotti: '',
    descrizione: '',
    idFornitore: 0,
    tipoMovimento: ''
}

const reducer = (state, { type, payload }) => {
    switch (type) {
        case 'SPOSTA':
            return {
                ...state,
                idMagazzinoPartenza: '',
                idMagazzinoDestinazione: '',
                dataOperazione: moment().format('YYYY-MM-DD'),
                prodotti: [],
                descrizione: '',
                idFornitore: 0,
                tipoMovimento: 'SPOSTA'

            }

        case 'CARICA':
            return {
                ...state,
                idMagazzinoPartenza: '',
                idMagazzinoDestinazione: 0,
                dataOperazione: moment().format('YYYY-MM-DD'),
                prodotti: [],
                descrizione: '',
                idFornitore: 0,
                tipoMovimento: 'CARICO'

            }
        case 'SCARICA':
            return {
                ...state,
                idMagazzinoPartenza: '',
                idMagazzinoDestinazione: 0,
                dataOperazione: moment().format('YYYY-MM-DD'),
                prodotti: [],
                descrizione: '',
                idFornitore: 0,
                tipoMovimento: 'SCARICO'
            }
        case 'RETTIFICA':
            return {
                ...state,
                idMagazzinoPartenza: '',
                idMagazzinoDestinazione: 0,
                dataOperazione: moment().format('YYYY-MM-DD'),
                prodotti: [],
                descrizione: '',
                idFornitore: 0,
                tipoMovimento: 'RETTIFICA'
            }

        case 'MAGAZZINO_SELEZIONATO':
            return {
                ...state,
                idMagazzinoPartenza: payload
            }
        case 'MAGAZZINO_DESTINATARIO':
            return {
                ...state,
                idMagazzinoDestinazione: payload
            }
        case 'DATA_SELEZIONATA':
            return { ...state, dataOperazione: moment(payload[0]).format('YYYY-MM-DD') }
        case 'DESCRIZIONE':
            return { ...state, descrizione: payload }
        case 'PRODOTTI': {
            const prodottoEsistente = state.prodotti.some(p => p.id === payload.id);
            const nuoviProdotti = prodottoEsistente
                ? state.prodotti.map(p => p.id === payload.id ? payload : p)
                : [...state.prodotti, payload];
            return {
                ...state,
                prodotti: nuoviProdotti
            };
        }

        default:
            return state
    }
}
const ButtonsWarehouse = (props) => {
    const { id, refresh, isLoading } = props
    const [canvasPlacement, setCanvasPlacement] = useState('start')
    const [canvasOpen, setCanvasOpen] = useState(false)
    const [state, dispatch] = useReducer(reducer, initialState)

    const toggleCanvasEnd = () => {
        setCanvasPlacement('end')
        setCanvasOpen(!canvasOpen)
    }
    const onError = (errors, e) => {
        toast.error('Controlla i campi richiesti', {
            position: "top-right",
            duration: 3000,
            style: {
                background: 'red',
                color: 'white'
            }
        })
    };
    console.log(state)
    // SE TUTTO E' VALIDATO CHIAMO ONSUBMIT
    const onSubmit = () => {
        if (state.prodotti.length > 0) {
            invioModifica()
            toggleCanvasEnd()
        }

        else toast.error('Nessun prodotto inserito', {
            position: "top-right",
            duration: 3000,
            style: {
                background: 'red',
                color: 'white'
            }
        })

    }

    const invioModifica = async () => {

        const myResponse = await axios(configSetMovimentiMagazzino([state]))
        if (myResponse.data.esito === 'OK') {
            toast.success('Quantità aggiornata/e con successo', {
                position: "top-right",
                duration: 3000,
                style: {
                    background: 'green',
                    color: 'white'
                }
            })
            if (refresh) {
                refresh(myResponse.data.Movimenti.map(el => {
                    const movimento = {
                        codiceMagazzino: el.codice_magazzino,
                        codiceProdotto: el.codice_prodotto,
                        codicePuntovendita: el.codice_puntovendita,
                        dataOperazione: new Date(el.data_operazione),
                        descrizione: el.descrizione,
                        id: el.id,
                        idDcoumento: el.id_docoumento,
                        idFornitore: el.id_fornitore,
                        idMagazzino: el.id_magazzino,
                        idProdotto: el.id_prodotto,
                        idProduttore: el.id_produttore,
                        idPuntovendita: el.id_puntovendita,
                        importoRiga: el.importo_riga,
                        iva: el.iva,
                        nomeMagazzino: el.nome_magazzino,
                        nomeProdotto: el.nome_prodotto,
                        note: el.note,
                        prezzo: el.prezzo,
                        quantita: parseFloat(el.quantita).toFixed(2),
                        tipoMovimento: el.tipo_movimento,
                        unitaMisura: el.unita_misura,
                        tipoProdotto: el.tipo_prodotto,
                    }
                    return movimento
                }))
            }
        } else {
            {
                toast.error('Si è verificato un errore durante la richiesta al server', {
                    position: "top-right",
                    duration: 3000,
                    style: {
                        background: 'red',
                        color: 'white'
                    }
                })
            }

        }
    }
    const trasmettiProdotti = (data) => {
        dispatch({ type: 'PRODOTTI', payload: data })

    }

    const defaultSchema = yup.object().shape({
        idMagazzinoPartenza: yup.number().required(),
        descrizione: yup.string().required(),
    })
    //useForm per la validazione
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({ mode: 'onChange', resolver: yupResolver(defaultSchema), defaultValues: state })
    return (

        <Row>
            <Col className='d-flex' style={{}}>
                <Button id='bottoneCarica' disabled={isLoading} className='m-1 sm' onClick={(e) => {
                    toggleCanvasEnd()
                    dispatch({ type: 'CARICA' })
                }} color='primary'>Carica</Button>
                <Button id='bottoneScarica' disabled={isLoading} className='m-1' onClick={(e) => {
                    toggleCanvasEnd()
                    dispatch({ type: 'SCARICA' })
                }} color='primary'>Scarica</Button>
                <Button id='bottoneSposta' disabled={isLoading} className='m-1' onClick={(e) => {
                    toggleCanvasEnd()
                    dispatch({ type: 'SPOSTA' })
                }} color='primary'>Sposta</Button>
                <Button id='bottoneRettifica' disabled={isLoading} className='m-1' onClick={(e) => {
                    toggleCanvasEnd()
                    dispatch({ type: 'RETTIFICA' })
                }} color='primary'>Rettifica</Button>
            </Col>
            <>
                <Offcanvas style={{ width: '1200px' }} direction={canvasPlacement} isOpen={canvasOpen} toggle={toggleCanvasEnd}>
                    <OffcanvasHeader toggle={() => {
                        reset()
                        toggleCanvasEnd()
                    }}> {state.tipoMovimento} </OffcanvasHeader>
                    <OffcanvasBody
                        className='my-auto mx-0'>
                        <Form onSubmit={handleSubmit(onSubmit, onError)}>
                            <Row>
                                <Col className='mb-1' xl='6' md='6' sm='12'>
                                    <Label className='form-label' for='magazzino'>
                                        Magazzino
                                    </Label>
                                    <Controller
                                        name='idMagazzinoPartenza'
                                        className='react-select'
                                        classNamePrefix='select'
                                        control={control}
                                        render={({ field: { value, onChange, ...field } }) => <AsyncSelect
                                            {...field}
                                            defaultInputValue='Magazzino'
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={async () => {
                                                const myResponse = await axios(configGetMagazzini({}))
                                                const prodotti = myResponse.data.magazzini.map(item => ({

                                                    ...item,
                                                    label: item.nome,
                                                    value: item.id,
                                                }));
                                                return prodotti;
                                            }}
                                            onChange={(e) => {
                                                onChange(e.id);
                                                dispatch({ type: 'MAGAZZINO_SELEZIONATO', payload: e.id })
                                            }}
                                            invalid={errors.idMagazzinoPartenza && true} />}
                                    />
                                    {errors.idMagazzinoPartenza && <FormFeedback>{errors.idMagazzinoPartenza.message}</FormFeedback>}
                                    <Fragment>
                                        <Label className='form-label' for='fineSupporto'>
                                            Data Operazione
                                        </Label>
                                        <Flatpickr className='form-control' options={{ dateFormat: "Y-m-d" }} placeholder='Inserisci Data' value={state.dataOperazione} onChange={date => dispatch({ type: 'DATA_SELEZIONATA', payload: date })} id='fineSupporto' />
                                    </Fragment>
                                    <Label className='form-label' for='note'>
                                        Descrizione
                                    </Label>
                                    <Controller
                                        id='descrizione'
                                        name='descrizione'
                                        defaultValue=''
                                        control={control}
                                        render={({ field: { value, onChange, ...field } }) => <Input {...field} onChange={({ target: { value } }) => {
                                            onChange(value);
                                            dispatch({ type: 'DESCRIZIONE', payload: value })
                                        }}
                                            value={state.descrizione || ''}
                                            invalid={errors.descrizione && true} />}
                                    />
                                    {errors.descrizione && <FormFeedback>{errors.descrizione.message}</FormFeedback>}
                                </Col>
                                <Col className={state.tipoMovimento === 'SPOSTA' ? 'd-block' : 'd-none'} xl='6' md='6' sm='12'>
                                    <Label className='form-label' for='idMagazzinoDestinatario'>
                                        Magazzino Destinatario
                                    </Label>
                                    <Controller
                                        name='idMagazzinoDestinatario'
                                        className='react-select'
                                        classNamePrefix='select'
                                        control={control}
                                        render={({ field: { value, onChange, ...field } }) => <AsyncSelect
                                            {...field}
                                            defaultInputValue='Magazzino Destinatario'
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={async () => {
                                                const myResponse = await axios(configGetMagazzini({}))
                                                const prodotti = myResponse.data.magazzini.map(item => ({

                                                    ...item,
                                                    label: item.nome,
                                                    value: item.id,
                                                }));
                                                return prodotti;
                                            }}
                                            onChange={(e) => {
                                                onChange(e.id);
                                                dispatch({ type: 'MAGAZZINO_DESTINATARIO', payload: e.id })
                                            }}
                                            invalid={errors.idMagazzinoDestinazione && true} />}
                                    />
                                    {errors.idMagazzinoDestinazione && <FormFeedback>{errors.idMagazzinoDestinazione.message}</FormFeedback>}
                                </Col>
                            </Row>
                            <TestTabella id={id} idMagazzino={state.idMagazzinoPartenza} tipoMovimento={state.tipoMovimento} trasmettiProdotti={(data) => trasmettiProdotti(data)} ></TestTabella>
                            <Button color='primary' type='Submit' disabled={!state.prodotti.length > 0}>Salva</Button>
                        </Form>
                    </OffcanvasBody>
                </Offcanvas>
            </>
        </Row>

    )
}

export default ButtonsWarehouse